import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';

import { getItemPresentation, getItemMeatPresentation } from '../../utils/Helpers';

const empty_line = {
  marginTop: '2mm'
}

const groupItemsByNameGradeBrand = (items) => {
  return items.reduce((memo, item) => {
    let grade = (item.extra_info && item.extra_info.grade)? item.extra_info.grade.grade: 'N/A';
    let brand = item.brand ? item.brand.brand_name : 'No Brand';
    let inventory_units = item.weight && item.weight > 0 && item.item.is_unit_price ? item.weight : 1
    let price = Math.round(parseFloat(parseFloat(item.shipment_price) * inventory_units) * 100 + 0.0001) / 100; //Adding 0,0001 to fix round representation
    let packs = item.item.is_unit_price ? 1 : item.item.packs;

    if (memo[item.item.name]) {
        if (memo[item.item.name][grade]){
          if (memo[item.item.name][grade][brand]) {
            // var tempSum = Number(parseFloat(memo[item.item.name][grade][brand].totalAmmount)) + item_weight;
            var tempPrice = (Number(parseFloat(memo[item.item.name][grade][brand].totalPrice)) + price).toFixed(2);
            let aux_weight = parseFloat(
                Number(memo[item.item.name][grade][brand].totalAmmount) + inventory_units, 2)
            let aux_price = parseFloat(
                Number(memo[item.item.name][grade][brand].totalPriceAux) + price, 2)
            memo[item.item.name][grade][brand].items.push(item);
            memo[item.item.name][grade][brand].averagePrice = parseFloat(aux_price / aux_weight, 2).toFixed(2);
            let aux_item_num = memo[item['item']['name']][grade][brand].itemNumber;
            memo[item.item.name][grade][brand].itemNumber = aux_item_num ? aux_item_num : item.qb_mapping;
            memo[item.item.name][grade][brand].totalPrice = tempPrice;
            memo[item.item.name][grade][brand].qty += inventory_units
            memo[item.item.name][grade][brand].qty = Number(parseFloat(memo[item.item.name][grade][brand].qty).toFixed(2));
            memo[item.item.name][grade][brand].unitPrice = (tempPrice/memo[item.item.name][grade][brand].qty).toFixed(2);

            memo[item.item.name][grade][brand].totalUnits += item.inventory_quantity
            memo[item.item.name][grade][brand].totalUnits = Number(parseFloat(memo[item.item.name][grade][brand].totalUnits).toFixed(2));
            memo[item.item.name][grade][brand].packageUnits = Math.ceil(
              memo[item.item.name][grade][brand].totalUnits / (
                memo[item.item.name][grade][brand].packs *
                memo[item.item.name][grade][brand].qty
              )
            ).toFixed(2);
          } else {
            memo[item.item.name][grade][brand] = {}
            memo[item.item.name][grade][brand].items = [item];

            let aux_item_num = memo[item['item']['name']][grade][brand].itemNumber;
            memo[item.item.name][grade][brand].itemNumber = aux_item_num ? aux_item_num : item.qb_mapping;

            memo[item.item.name][grade][brand].totalPrice = price;
            memo[item.item.name][grade][brand].qty = inventory_units
            memo[item.item.name][grade][brand].unitPrice = (price/inventory_units).toFixed(2);
            memo[item.item.name][grade][brand].packs = packs

            memo[item.item.name][grade][brand].totalUnits = item.inventory_quantity
            memo[item.item.name][grade][brand].packageUnits = Math.ceil(
              memo[item.item.name][grade][brand].totalUnits / (
                memo[item.item.name][grade][brand].packs *
                memo[item.item.name][grade][brand].qty
              )
            ).toFixed(2);

          }
        } else {
          memo[item.item.name][grade] = {}
          memo[item.item.name][grade][brand] = {}
          memo[item.item.name][grade][brand].items = [item];

          let aux_item_num = memo[item['item']['name']][grade][brand].itemNumber;
          memo[item.item.name][grade][brand].itemNumber = aux_item_num ? aux_item_num : item.qb_mapping;

          memo[item.item.name][grade][brand].totalPrice = price;
          memo[item.item.name][grade][brand].qty = inventory_units
          memo[item.item.name][grade][brand].unitPrice = (price/inventory_units).toFixed(2);

          memo[item.item.name][grade][brand].packs = packs
          memo[item.item.name][grade][brand].totalUnits = item.inventory_quantity
          memo[item.item.name][grade][brand].packageUnits = Math.ceil(
            memo[item.item.name][grade][brand].totalUnits / (
              memo[item.item.name][grade][brand].packs *
              memo[item.item.name][grade][brand].qty
            )
          ).toFixed(2);
        }
    } else {
      memo[item.item.name] = {};
      memo[item.item.name][grade] = {}
      memo[item.item.name][grade][brand] = {}
      memo[item.item.name][grade][brand].items = [item];

      let aux_item_num = memo[item['item']['name']][grade][brand].itemNumber;
      memo[item.item.name][grade][brand].itemNumber = aux_item_num ? aux_item_num : item.qb_mapping;

      memo[item.item.name][grade][brand].totalPrice = price;
      memo[item.item.name][grade][brand].qty = inventory_units
      memo[item.item.name][grade][brand].unitPrice = (price/inventory_units).toFixed(2);

      memo[item.item.name][grade][brand].packs = packs
      memo[item.item.name][grade][brand].totalUnits = item.inventory_quantity
      memo[item.item.name][grade][brand].packageUnits = Math.ceil(
        memo[item.item.name][grade][brand].totalUnits / (
          memo[item.item.name][grade][brand].packs *
          memo[item.item.name][grade][brand].qty
        )
      ).toFixed(2);
    }

    return memo
  }, {})
}

const PackageTableHeader = () => {
  let header={background:'#e9ebec', borderCollapse: 'collapse'},
      headerRow={border:'1px solid gray'},
      firstHeaderRow={border:'1px solid gray', width:'20%'},
      largeHeaderRow={border:'1px solid gray', width: '50%'}
  return (
    <thead style={header}>
      <tr>
        <td style={firstHeaderRow}><b>Item Number</b></td>
        <td style={headerRow}><b>Item Name</b></td>
        <td style={headerRow}><b>Grade</b></td>
        <td style={headerRow} colSpan="2"><b>Case Presentation</b></td>
        <td style={largeHeaderRow}><b>Weight</b></td>
        <td style={headerRow}><b>Qty</b></td>
        <td style={headerRow}><b>UOM</b></td>
        <td style={headerRow}><b>Unit Price</b></td>
        <td style={headerRow}><b>Total amount</b></td>
      </tr>
    </thead>
  )
}

const PackageTableRow = (props) => {
  let colPadding={paddingRight: '5px', border: '1px solid gray'},
      tableRow={}
  const uom = props.gItems.items[0].item.is_unit_price ? props.gItems.items[0].item.measure_unit : props.gItems.items[0].item.master_packing_type;
  return (
    <tr style={tableRow}>
      <td style={colPadding}>{props.gItems.itemNumber}</td>
      <td style={colPadding}>{props.gItems.items[0].item.name} - {props.gItems.items[0].brand ? props.gItems.items[0].brand.brand_name : 'No brand'} </td>
      <td style={colPadding}>{(props.gItems.items[0].extra_info && props.gItems.items[0].extra_info.grade)? props.gItems.items[0].extra_info.grade.grade: 'N/A'}</td>
      <td style={colPadding}>{props.gItems.packs}</td>
      {
        props.gItems.items[0].item.is_unit_price ? (
          <td style={colPadding}>{props.gItems.totalUnits}</td>
        ) : (
          <td style={colPadding}>{props.gItems.packageUnits}</td>
        )
      }
      <td style={colPadding}>
        {props.gItems.items.map((item, index) => {
          // let item_weight = !item.item.is_unit_price || item.weight === 0 ? 0 : item.weight;
          return (<span key={index}> {index > 0 ? '|':''} {item.weight}</span>)
        })}
      </td>
      <td style={colPadding}>{props.gItems.qty}</td>
      <td style={colPadding}>{uom}</td>
      <td style={colPadding}>{props.gItems.unitPrice || '-'}</td>
      <td style={colPadding}>{parseFloat(props.gItems.totalPrice).toFixed(2)}</td>
    </tr>
  )
}

const PrintItemsList = (props) => {
  if (props.items && props.items.length > 0) {
    let groupedItems = groupItemsByNameGradeBrand(props.items),
        table = {border: '1px solid gray', width: '100%', textAlign:'center', borderCollapse:'collapse'}
    // Order the Shipment's items alphabetically by the item name.
    let orderedGroupItems = Object.keys(groupedItems).sort().map((key) => {
      return groupedItems[key];
    })
    return (
      <div>
        <div style={empty_line}></div>
        <table style={table}>
          <PackageTableHeader/>
          <tbody>
          { _.map(orderedGroupItems, (itemsByName, keyName) => {
            return _.map(itemsByName, (itemsByGrade, keyGrade) => {
              return _.map(itemsByGrade, (gItems2, keyBrand) => {
                  return (
                    <PackageTableRow gItems={gItems2} key={keyBrand}/>
                    )
                })
              });
            })
          }
        </tbody>
      </table>
    </div>
    );
  } else {
    return null
  }
}

const PrintPackage = (props) => {
  let empty_line2 = { marginTop: '8mm' },
      alignLeft = {textAlign: 'left'}
  return (
    <div>
      <div style={empty_line2}></div>
      <div style={alignLeft}><b>Package #{props.pack.id} | {props.pack.package_type ? props.pack.package_type.name : 'N/A'}</b></div>
      <PrintItemsList items={props.pack.items} />
    </div>
  );
};

const PrintPackagesList = (props) => {
  if (props.packages && props.packages.length > 0) {
    return (
      <div>
        <div style={empty_line}></div>
        {props.packages.map((pack, index) => {
          return (
            <div id={index} key={index}>
              <PrintPackage pack={pack}/>
            </div>
          );
        })}
      </div>
    );
  } else {
    return null
  }
}

const ShipmentTotalPrice = (props) => {
  let total = 0
  let mtop = {marginTop: '30px', textAlign: 'left', backgroundColor: 'yellow'}
  _.each(props.packages, (pack)=>{
    _.each(pack.items, (item)=>{
      let item_weight = !item.item.is_unit_price || item.weight === 0 ? 1 : item.weight;
      total += Math.round(item.shipment_price * item_weight * 100) / 100;
    })
  })
  return (
    <div style={mtop}><b>Total:</b> {total.toFixed(2)}</div>
  )
}

const BackOrderData = ({ items }) => {
  const mtop = {marginTop: '30px', textAlign: 'left'};
  const header = {background:'#e9ebec', borderCollapse: 'collapse'};
  const headerRow = {border:'1px solid gray'};
  const largeHeaderRow = {border:'1px solid gray', width:'50%'};
  const colPadding={paddingRight: '5px', border: '1px solid gray'};
  if (items.length === 0) {
    return null;
  }

  return (
    <div style={{display: 'block'}}>
      <div style={mtop}>
        <b>Items in Back Order:</b>
      </div>
      <table style={{width: '100%'}}>
        <thead style={header}>
          <tr>
            <td style={largeHeaderRow}><b>Item</b></td>
            <td style={headerRow}><b>Presentation</b></td>
            <td style={headerRow}><b>Pending Qty</b></td>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const presentation = getItemPresentation(item);
            return (
              <tr key={item.id}>
                <td style={colPadding}>{item ? item.name : ""} {item.grade !== null ? `(Grade: ${item.grade})` : ''}</td>
                <td style={colPadding}>
                  {presentation ? presentation : getItemMeatPresentation(item, item.presentation)}
                </td>
                <td style={colPadding}>{item.back_order_amount}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default class PrintShipmentList extends Component {

  render() {
    const table = {
      border:'1px solid gray',
      width: '100%',
      borderCollapse: 'collapse',
      textAlign: 'center',
    };
    const tableRow = { border:'1px solid gray' };
    const { backOrder } = this.props;
    return (
      <div className="toPrintShipment text-center" id={"toPrint"}>
        <div>
          <p className="text-left">
            MG Products LLC <br/>
            2678 NW 112 AV <br/>
            Doral FL 33172
          </p>
          <table style={table}>
            <thead>
              <tr>
                <td style={tableRow}><b>Invoice </b>#{this.props.shipment.id}</td>
                <td style={tableRow}><b>Ship to: </b>{this.props.shipment.destination.name}</td>
                <td style={tableRow}><b>User: </b>{this.props.shipment.user}</td>
                <td style={tableRow}>
                  <b>Date: </b>
                  {this.props.shipment.creation_date ? moment(this.props.shipment.creation_date).format('L') : '-'}
                </td>
              </tr>
            </thead>
          </table>
        </div>

        <PrintPackagesList packages={this.props.shipment.packages} />
        <ShipmentTotalPrice packages={this.props.shipment.packages} />
        {backOrder && <BackOrderData items={backOrder}/>}
      </div>
    );
  }
}
